import { render, staticRenderFns } from "./VueFeatherIconPack.vue?vue&type=template&id=b5c2f218&"
import script from "./VueFeatherIconPack.vue?vue&type=script&lang=js&"
export * from "./VueFeatherIconPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports